module.exports = __webpack_public_path__ + "img/payment-success.f1e6824c.png";